<template>
<div>
    <h1 class="mb-4 text-gray-500">All Downloaders</h1>
    <div class="flex gap-5 flex-wrap" >
        <router-link v-for="website in websites" :key="website.name" :to="website.link">
            <el-card shadow="never" :body-style="{ padding: '20px', width: '400px' }">
                <div class="flex align-center gap-5 justify-between">
                    <h1 class="mb-0"> {{ website.name }} </h1> 
                    <el-tag size="small" v-if="!website.live" type="primary" effect="dark">Coming soon</el-tag>
                    <el-tag size="small" v-if="website.beta" type="warning" effect="dark">Beta</el-tag>
                </div>
                <div>
                    <!-- {{website.description}} -->
                </div>
            </el-card>
        </router-link>
    </div>
</div>
</template>
<script>
export default {
    created() {
        useHead({
            title: 'List of websites supported to download media files',
            head: {
                meta: [
                    {
                        hid: 'description',
                        name: 'description',
                        content: 'List of all websites supported by anyloader to download videos and photos in bulk using chrome extension',
                    }
                ]
            }
        })
    },
    data () {
        return {
            websites: [
                {
                    name: 'Onlyfans downloader',
                    description: 'Onlyfans downloader is a software designed to allow users to download content from onlyfans.com, from posts, profiles and chats for offline viewing.',
                    thumbnail: '',
                    link: '/',
                    live: true,
                },
                {
                    name: 'Fansly downloader',
                    description: 'Fansly downloader is a software designed to allow users to download content from fansly.com, from posts, profiles and chats for offline viewing.',
                    thumbnail: '',
                    link: '/fansly-downloader',
                    live: true,
                    beta: true
                },
                {
                    name: 'Redgifs Downloader',
                    description: 'Redgifs downloader is a software designed to allow users to download content from redgifs.com, from posts, profiles and chats for offline viewing.',
                    thumbnail: '',
                    link: '/redgifs-downloader',
                    live: true,
                    beta: true
                },
                {
                    "name": "YouTube Downloader",
                    "description": "YouTube Downloader is a tool that lets you download videos from YouTube for offline viewing. It's a simple and easy-to-use software that allows you to save your favorite YouTube content for later.",
                    "thumbnail": "",
                    "link": "/youtube-downloader"
                },
                {
                    "name": "BiliBili Downloader",
                    "description": "BiliBili Downloader is a tool that enables you to download videos from BiliBili for offline viewing. This software allows you to save your favorite BiliBili content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/bilibili-downloader"
                },
                {
                    "name": "Youku Downloader",
                    "description": "Youku Downloader is a tool that lets you download videos from Youku for offline viewing. With this software, you can save your favorite Youku content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/youku-downloader"
                },
                {
                    "name": "Vimeo Downloader",
                    "description": "Vimeo Downloader is a tool that allows you to download videos from Vimeo for offline viewing. This software enables you to save your favorite Vimeo content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/vimeo-downloader"
                },
                {
                    "name": "Facebook Downloader",
                    "description": "Facebook Downloader is a tool that lets you download videos from Facebook for offline viewing. With this software, you can save your favorite Facebook content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/facebook-downloader"
                },
                {
                    "name": "Instagram Downloader",
                    "description": "Instagram Downloader is a tool that allows you to download photos and videos from Instagram for offline viewing. This software enables you to save your favorite Instagram content for later, so you can view it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/instagram-downloader"
                },
                {
                    "name": "TikTok Downloader",
                    "description": "TikTok Downloader is a tool that lets you download videos from TikTok for offline viewing. With this software, you can save your favorite TikTok content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/tiktok-downloader"
                },
                {
                    "name": "Twitter Downloader",
                    "description": "Twitter Downloader is a tool that allows you to download photos and videos from Twitter for offline viewing. This software enables you to save your favorite Twitter content for later, so you can view it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/twitter-downloader"
                },
                {
                    "name": "Reddit Downloader",
                    "description": "Reddit Downloader is a tool that lets you download photos and videos from Reddit for offline viewing. With this software, you can save your favorite Reddit content for later, ensuring you can view it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/reddit-downloader"
                },
                {
                    "name": "Periscope Downloader",
                    "description": "Periscope Downloader is a tool that allows you to download videos from Periscope for offline viewing. This software enables you to save your favorite Periscope content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/periscope-downloader"
                },
                {
                    "name": "Twitch Downloader",
                    "description": "Twitch Downloader is a tool that lets you download videos from Twitch for offline viewing. With this software, you can save your favorite Twitch content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/twitch-downloader"
                },
                {
                    "name": "TED Downloader",
                    "description": "TED Downloader is a tool that allows you to download videos from TED for offline viewing. This software enables you to save your favorite TED talks for later, so you can watch them whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/ted-downloader"
                },
                {
                    "name": "Behance Downloader",
                    "description": "Behance Downloader is a tool that lets you download images from Behance for offline viewing. With this software, you can save your favorite Behance content for later, ensuring you can view it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/behance-downloader"
                },
                {
                    "name": "Deviantart Downloader",
                    "description": "Deviantart Downloader is a tool that allows you to download images from Deviantart for offline viewing. This software enables you to save your favorite Deviantart content for later, so you can view it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/deviantart-downloader"
                },
                {
                    "name": "SoundCloud Downloader",
                    "description": "SoundCloud Downloader is a tool that lets you download music from SoundCloud for offline listening. With this software, you can save your favorite SoundCloud tracks for later, ensuring you can listen to them anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/soundcloud-downloader"
                },
                {
                    "name": "Bandcamp Downloader",
                    "description": "Bandcamp Downloader is a tool that allows you to download music from Bandcamp for offline listening. This software enables you to save your favorite Bandcamp tracks for later, so you can listen to them whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/bandcamp-downloader"
                },
                {
                    "name": "Audiomack Downloader",
                    "description": "Audiomack Downloader is a tool that lets you download music from Audiomack for offline listening. With this software, you can save your favorite Audiomack tracks for later, ensuring you can listen to them anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/audiomack-downloader"
                },
                {
                    "name": "Xvideos Downloader",
                    "description": "Xvideos Downloader is a tool that allows you to download videos from Xvideos.com for offline viewing. This software enables you to save your favorite Xvideos content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/xvideos-downloader"
                },
                {
                    "name": "XNXX Downloader",
                    "description": "XNXX Downloader is a tool that lets you download videos from XNXX.com for offline viewing. With this software, you can save your favorite XNXX content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/xnxx-downloader"
                },
                {
                    "name": "xHamster Downloader",
                    "description": "xHamster Downloader is a tool that allows you to download videos from xHamster.com for offline viewing. This software enables you to save your favorite xHamster content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/xhamster-downloader"
                },
                {
                    "name": "SpankBang Downloader",
                    "description": "SpankBang Downloader is a tool that lets you download videos from SpankBang.com for offline viewing. With this software, you can save your favorite SpankBang content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/spankbang-downloader"
                },
                {
                    "name": "Motherless Downloader",
                    "description": "Motherless Downloader is a tool that allows you to download videos from Motherless.com for offline viewing. This software enables you to save your favorite Motherless content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/motherless-downloader"
                },
                {
                    "name": "Eporner Downloader",
                    "description": "Eporner Downloader is a tool that lets you download videos from Eporner.com for offline viewing. With this software, you can save your favorite Eporner content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/eporner-downloader"
                },
                {
                    "name": "Shesfreaky Downloader",
                    "description": "Shesfreaky Downloader is a tool that allows you to download videos from Shesfreaky.com for offline viewing. This software enables you to save your favorite Shesfreaky content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/shesfreaky-downloader"
                },
                {
                    "name": "HDsex Downloader",
                    "description": "HDsex Downloader is a tool that lets you download videos from HDsex.com for offline viewing. With this software, you can save your favorite HDsex content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/hdsex-downloader"
                },
                {
                    "name": "Beeg Downloader",
                    "description": "Beeg Downloader is a tool that allows you to download videos from Beeg.com for offline viewing. This software enables you to save your favorite Beeg content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/beeg-downloader"
                },
                {
                    "name": "The Fantazy Downloader",
                    "description": "The Fantazy Downloader is a tool that lets you download videos from TheFantazy.com for offline viewing. With this software, you can save your favorite TheFantazy content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/thefantazy-downloader"
                },
                {
                    "name": "TXXX Downloader",
                    "description": "TXXX Downloader is a tool that allows you to download videos from TXXX.com for offline viewing. This software enables you to save your favorite TXXX content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/txxx-downloader"
                },
                {
                    "name": "HClips Downloader",
                    "description": "HClips Downloader is a tool that lets you download videos from HClips.com for offline viewing. With this software, you can save your favorite HClips content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/hclips-downloader"
                },
                {
                    "name": "Porntrex Downloader",
                    "description": "Porntrex Downloader is a tool that allows you to download videos from Porntrex.com for offline viewing. This software enables you to save your favorite Porntrex content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/porntrex-downloader"
                },
                {
                    "name": "Tnaflix Downloader",
                    "description": "Tnaflix Downloader is a tool that lets you download videos from Tnaflix.com for offline viewing. With this software, you can save your favorite Tnaflix content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/tnaflix-downloader"
                },
                {
                    "name": "Kompoz Downloader",
                    "description": "Kompoz Downloader is a tool that allows you to download videos from Kompoz.com for offline viewing. This software enables you to save your favorite Kompoz content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/kompoz-downloader"
                },
                {
                    "name": "Perfectgirls Video Downloader",
                    "description": "Perfectgirls Video Downloader is a tool that lets you download videos from Perfectgirls.com for offline viewing. With this software, you can save your favorite Perfectgirls content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/perfectgirls-downloader"
                },
                {
                    "name": "Chaturbate Downloader",
                    "description": "Chaturbate Downloader is a tool that allows you to download videos from Chaturbate.com for offline viewing. This software enables you to save your favorite Chaturbate content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/chaturbate-downloader"
                },
                {
                    "name": "aShemaleTube Downloader",
                    "description": "aShemaleTube Downloader is a tool that lets you download videos from aShemaleTube.com for offline viewing. With this software, you can save your favorite aShemaleTube content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/ashemaletube-downloader"
                },
                {
                    "name": "ShemaleZ Downloader",
                    "description": "ShemaleZ Downloader is a tool that allows you to download videos from ShemaleZ.com for offline viewing. This software enables you to save your favorite ShemaleZ content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/shemalez-downloader"
                },
                {
                    "name": "BoyfriendTV Downloader",
                    "description": "BoyfriendTV Downloader is a tool that lets you download videos from BoyfriendTV.com for offline viewing. With this software, you can save your favorite BoyfriendTV content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/boyfriendtv-downloader"
                },
                {
                    "name": "Hanime Downloader",
                    "description": "Hanime Downloader is a tool that allows you to download videos from Hanime.tv for offline viewing. This software enables you to save your favorite Hanime content for later, so you can watch it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/hanime-downloader"
                },
                {
                    "name": "nHentai Downloader",
                    "description": "nHentai Downloader is a tool that lets you download videos from nHentai.net for offline viewing. With this software, you can save your favorite nHentai content for later, ensuring you can watch it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/nhentai-downloader"
                },
                {
                    "name": "PornPics Downloader",
                    "description": "PornPics Downloader is a tool that allows you to download images from PornPics.com for offline viewing. This software enables you to save your favorite PornPics content for later, so you can view it whenever you want, even without an internet connection.",
                    "thumbnail": "",
                    "link": "/pornpics-downloader"
                },
                {
                    "name": "ImageFap Downloader",
                    "description": "ImageFap Downloader is a tool that lets you download images from ImageFap.com for offline viewing. With this software, you can save your favorite ImageFap content for later, ensuring you can view it anytime, even when you're offline.",
                    "thumbnail": "",
                    "link": "/imagefap-downloader"
                }

            ]
        }
    }
}
</script>